/*
 * Action Types
 */
export enum BpeTypes {
  GET_BPE_CONFIG_REQUEST = '@bpe/GET_BPE_CONFIG_REQUEST',
  GET_BPE_CONFIG_SUCCESS = '@bpe/GET_BPE_CONFIG_SUCCESS',
  GET_BPE_CONFIG_FAILURE = '@bpe/GET_BPE_CONFIG_FAILURE',

  UPDATE_BPE_CONFIG_REQUEST = '@bpe/UPDATE_BPE_CONFIG_REQUEST',
  UPDATE_BPE_CONFIG_SUCCESS = '@bpe/UPDATE_BPE_CONFIG_SUCCESS',
  UPDATE_BPE_CONFIG_FAILURE = '@bpe/UPDATE_BPE_CONFIG_FAILURE',
}

/*
 * Data types
 */
export interface BpeConfigInterface {
  id: string;
  privateKey: string;
  publicKey: string;
  pfx: string;
  certificatePassword: string;
  cityIBGECode: string;
  uf: string;
  ie: string;
  iest: string;
  im: string;
  cnae: string;
  crt: number;
  tar: string;
  icms: string;
  icmsUFFim: string;
  transportType: number;
  cfop: string;
  isMetropolitan: boolean;
  saleEmissionTypes: string[] | null;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface BpeState {
  readonly bpeConfigData: BpeConfigInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
